/* eslint-disable no-unused-vars */
import { axios } from './index'
import getPrefJSON from "../constants/prefData.js";

const resource = '/v1/stay'

export default {
  searchPlan(params) {
    // console.log('**************************************************')
    // console.log(JSON.stringify(params))
    // return Repository.get(`${resource}/plan`, { params })
    return axios.get(`${resource}/search/plan`, { params })
  },
  searchMenu(body, params) {
    // CRM独自対応
    const companyCd = sessionStorage.getItem('companyCd') || ''
    const disableRakuten = companyCd !== '' &&
      process.env.VUE_APP_DISABLE_RAKUTEN_TRAVEL
        ?.split(',')
        .includes(companyCd)
    const requestBody = { ...body };

    if (disableRakuten) {
      delete requestBody.isRakuten;
    }
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/search/menu`, requestBody, { params }).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error?.data)
        }
      )
    })
  },
  searchMenuList(params) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/menu/menu-list`, { params }).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error?.data)
        }
      )
    })
  },

  /* ========= PUBLIC STAY ========= */
  searchMenuPublicStay(body, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/search/public/stay`, body, { params }).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error?.data)
        }
      )
    })
  },

  getCodesArea(params) {
	//return getCodesAreaJSON(params);
	//console.log(axios.get(`${resource}/codes/area`, { params }));
    return axios.get(`${resource}/codes/area`, { params });
  },

  async getLargeCodesArea() {
    return getPrefJSON();
  },

}
